import { ApiService } from 'react-angle-dashboard-components'

export class BrokerService extends ApiService {
  async getGroupSuperuserToken(groupId: string, authId?: number) {
    return this.request({
      method: 'post',
      // url: `/groups/${groupId}/broker/groups/${groupId}/users/${authId}/token`,
      url: `/groups/${groupId}/temp-auth`,
      credentials: true
    })
  }

  async getGroups() {
    return this.request({
      method: 'get',
      url: `/broker/groups`,
      credentials: true
    }).then((r: any) => r.data)
  }
}
